import Icon from '../components/Icon.vue'

Icon.register({"check":{"width":1792,"height":1792,"paths":[{"d":"M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/check.js
// module id = 428
// module chunks = 0